import { CheckIcon } from 'lucide-react';
type Props<T extends string> = {
  options: readonly T[];
  value: T[];
  onChange: (value: T[]) => void;
  /** Extra regeltje per optie, bijv. "12 producten". */
  meta?: (option: T) => string | undefined;
};

/** Meerkeuze uit een vaste lijst, als aanklikbare labels. */
export function ChipSelect<T extends string>({
  options,
  value,
  onChange,
  meta
}: Props<T>) {
  return <div className="flex flex-wrap gap-2" data-id="element-4912" data-mp="x34dwf0l53jo">
      {options.map(o => {
      const on = value.includes(o);
      const extra = meta?.(o);
      return <button key={o} type="button" aria-pressed={on} onClick={() => onChange(on ? value.filter(v => v !== o) : [...value, o])} className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-[13px] transition-colors duration-150 ease-soft ${on ? 'border-ink bg-ink text-shell' : 'border-line bg-white text-ink hover:border-ink/40'}`} data-id="element-4913" data-mp="s26ujz3ua3gl">
            {on && <CheckIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-4914" data-mp="3vexa0o7xw0wk" />}
            {o}
            {extra && <span className={on ? 'text-shell/70' : 'text-muted'} data-id="element-4915" data-mp="46svastwffnq">· {extra}</span>}
          </button>;
    })}
    </div>;
}